import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      navigate("/login");
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/google/callback", { session_id: sessionId });
        setUser(data.user);
        // Clear hash and go to dashboard
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { state: { user: data.user } });
      } catch (e) {
        console.error("Auth callback failed", e);
        navigate("/login");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#050507]" data-testid="auth-callback-loading">
      <div className="text-center">
        <div className="w-16 h-16 mx-auto mb-6 rounded-full border border-white/20 animate-pulse-slow silver-gradient" />
        <p className="label-mono">Securing your session</p>
      </div>
    </div>
  );
}
